import React from 'react';
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from 'shards-react';
const ProfileNotification = ({ closeModal, history }) => {
	const handleAction = (e) => {
		//console.log(e);
		history.push('/dashboard/profile');
		closeModal();
	};
	return (
		<Modal
			open={true}
			toggle={closeModal}
			backdrop={true}
			backdropClassName="backdrop"
			modalClassName="modal"
			fade={true}
			role="dialog"
		>
			<ModalHeader className="bg-primary1">Please update your profile</ModalHeader>
			<ModalBody>
				<p>
					Seems like your profile is empty. Please update your profile before proceeding to lodge a complaint
					so that our agents can get in touch with you for updates.
				</p>
			</ModalBody>
			<ModalFooter className="home-buttons d-flex w-100 justify-content-between px-3">
				<Button theme="danger" name="dismiss" onClick={closeModal}>
					Dismiss
				</Button>
				<Button theme="success" name="go_profile" onClick={(e) => handleAction(e)}>
					Go To Profile Page
				</Button>
			</ModalFooter>
		</Modal>
	);
};

export default ProfileNotification;
